<template>
    <field-wrapper
        id="controlNumbers"
        :label-text="label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="controlNumbers_input"
            v-model="value"
            type="text"
            aria-describedby="controlNumbers_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        value: {
            get() {
                return this.controlNumbers || "";
            },
            set(controlNumbers) {
                this.updateCustomer({ controlNumbers });
            }
        },
        label() {
            if (
                this.identificationType &&
                this.identificationType.useDigitsFromEnd
            ) {
                // Info: https://kazupon.github.io/vue-i18n/guide/pluralization.html#custom-pluralization
                return this.$t("field_customer_control_numbers.label_last", 1, {
                    count: this.identificationType.numberOfControlDigits
                });
            } else if (this.identificationType) {
                return this.$t(
                    "field_customer_control_numbers.label_first",
                    1,
                    { count: this.identificationType.numberOfControlDigits }
                );
            } else {
                // Default text untill an id is chosen
                return this.$t("field_customer_control_numbers.label_last", 1, {
                    count: 4
                });
            }
        },
        errorMessage() {
            if (this.validate && this.error) {
                const count = this.identificationType
                    ? this.identificationType.numberOfControlDigits
                    : 4;
                return this.$t(
                    "field_customer_control_numbers." + this.error,
                    1,
                    { count }
                );
            }
            return null;
        },
        ...mapGetters({
            controlNumbers: "customer/getControlNumbers",
            identificationType: "customer/getIdentificationType",
            error: "customer/getControlNumbersError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
